import React from "react";
import { Link } from "react-router-dom";
import { List, Card, Table, Tag, Button, Icon,Row, Col } from "antd";

// import  EyeFilled  from '@ant-design/icons';
import reduxCrud from "../redux";

import styled from "styled-components";

import ActionBtns from "../../../components/ActionBtns/ActionBtns";
//import { getMaxListeners } from "cluster";

import { MrRow } from "../../../components/UI/MrTable/MrTable";

import { MrColumn } from "../../../components/UI/MrTable/MrTable";
import PatientsHeader from "../PatientsHeader";
import "../PatientsStyle.css";
import Mrcard from "../../../components/UI/MrTable/Mrcard";
import { SlowBuffer } from "buffer";

import {
  EyeOutlined,
} from "@ant-design/icons";


// var createdDateTime = new Date(created_at);
// var createdDate = createdDateTime.toDateString();
// var createdTime = createdDateTime.toLocaleTimeString();

export const PatientColumns = [
  {
    title: "Name",
    dataIndex: "first_name",
    key: "name",
    render: (first_name, tableobj) => {
      console.log("firstname plus email", tableobj);
      // var createdDateTime = new Date(created_at)
      return (
        <span>
          {first_name + " " + tableobj.middle_name + " " + tableobj.last_name}
        </span>
      );
    }
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    editable: true
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone"
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age"
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "Address"
  },
  {
    title: "Gender",
    dataIndex: "gender",
    key: "gender"
  },
  {
    title: "Disorder",
    dataIndex: "disorders",
    key: "disorders",
    render: disorders => {
      if (disorders.length > 0) {
        var variable = disorders[0].name;
      }
      console.log("createdDateTiabbreviation", variable);
      return <span>{variable}</span>;
    }
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: created_at => {
      var createdDateTime = new Date(created_at);
      return <span>{createdDateTime.toLocaleString("en-US")}</span>;
    }
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
    render: updated_at => {
      var UpdatedDatetime = new Date(updated_at);
      return <span>{UpdatedDatetime.toLocaleString("en-US")}</span>;
    }
  },
  {
    title: "Action Button",
    dataIndex: "actionBtns",
    key: "actionBtns"
    // render: (actionBtns,tableobj) => {
    //   // console.log("firstname plus email",tableobj);
    //   // var createdDateTime = new Date(created_at)
    //   return (<span>{tableobj. }</span>)
    // },
  }
];

// const PatientColumns = ()=>
//   Name:`${item.first_name} ${item.middle_name} ${item.last_name}` ,
//   Email:item.email,
//   Phone:item.phone,
//   Age:item.age,
//   Address:item.address,
//   Gender:item.gender,
//   Disorder:variable,
//   CreatedDate: `${createdDate}${createdTime}`,
//   UpdatedDate:`${UpdatedDate}${UpdatedTime}`,

export const PatientsList = props => {
  const { item, resourceUrl } = props;
  console.log("props patients---------->", props);
  console.log("props patients item id---------->", props.item.id);

  var patientid = `${"/patients/" + props.item.id }` 
  console.log("papatientid----->" + patientid)
  // console.log("props age", item.age);
  // console.log("props patients disorders123 ---------->", item.disorders.length);

  // if (item.disorders.length > 0) {
  //   var variable = item.disorders[0].name;
  //   console.log("abbreviation", variable);
  // }

  // var all_disorders = ''
  // for (const disorder of item.disorders) {
  //   all_disorders += disorder.name + ', '
  // }

  var UpdatedDatetime = new Date(item.updated_at);
  var UpdatedDate = UpdatedDatetime.toDateString();
  var UpdatedTime = UpdatedDatetime.toLocaleTimeString();

  var createdDateTime = new Date(item.created_at);
  var createdDate = createdDateTime.toDateString();
  var createdTime = createdDateTime.toLocaleTimeString();

  const dataObject = {
    Name: `${item.name}`,
    Email: item.hosp_id,
    // Phone:item.phone,
    Age: item.age,
    // Address:item.address,
    Gender: item.gender,
    // Disorder:all_disorders,
    CreatedDate: `${createdDate}${createdTime}`,
    UpdatedDate: `${UpdatedDate}${UpdatedTime}`,
    ActionBtns: props.actionBtns
  };

  return (
    <Col span={24} >
      {/* <Mrcard dataObject={dataObject}  /> */}
      <List.Item>
        <MrRow className="desktop-only">
          {/* <MrColumn style={{ flex: 2 }}>{item.first_name} {item.middle_name} {item.last_name}</MrColumn> */}

          <MrColumn style={{ flex: 2 }}  >
            <Link to={patientid}>  {item.first_name} {item.middle_name} {item.last_name}</Link>
          </MrColumn>
          <MrColumn style={{ flex: 2 }}> {item.disorder_information.age_options} {item.disorder_information.age_radio ? (item.disorder_information.age_radio === "yes" ? "years" : "months") : "" } </MrColumn>
          {/* <MrColumn style={{ flex: 2.5 }}> {item.email} </MrColumn> */}
          {/* <MrColumn style={{ flex: 2 }}> {item.address} </MrColumn> */}
          <MrColumn style={{ flex: 2 }}> {item.disorder_information.gender} </MrColumn>
          <MrColumn style={{ flex: 2 }}>{item.disorder_information.disorder_type}</MrColumn>
          <MrColumn style={{ flex: 2 }}>{UpdatedDate} {UpdatedTime}</MrColumn>
          <MrColumn className="text-right" style={{ flex: 2,  left: 7  }}>
            {props.actionBtns}
          </MrColumn>
        </MrRow>
        <Mrcard dataObject={dataObject} />
      </List.Item>
      <Mrcard dataObject={dataObject} />
    </Col>
  );
};

export default PatientsList;
